"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var EmailExclusivesSection_1 = require("../EmailExclusives/EmailExclusivesSection");
var EmailExclusives = function (_a) {
    var products = _a.products, subHeaders = _a.subHeaders, bundleDiscount = _a.bundleDiscount;
    return ((0, preact_1.h)("div", { class: "shop-all-container" },
        (0, preact_1.h)(EmailExclusivesSection_1.default, { products: products, subCollection: "subscriptions", sectionSubHeader: subHeaders[1], isBundle: false, bundleDiscount: bundleDiscount }),
        (0, preact_1.h)("hr", { class: "sales-acquisition-shop__hr" }),
        (0, preact_1.h)(EmailExclusivesSection_1.default, { products: products, subCollection: "bundles", sectionSubHeader: subHeaders[0], isBundle: true, bundleDiscount: bundleDiscount }),
        (0, preact_1.h)("hr", { class: "sales-acquisition-shop__hr" }),
        (0, preact_1.h)(EmailExclusivesSection_1.default, { products: products, subCollection: "exclusives", sectionSubHeader: subHeaders[2], isBundle: false, bundleDiscount: bundleDiscount })));
};
exports.default = EmailExclusives;
